/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * Request body fields required and optional to operate on Budget data. This bean is shallow, which means its potential relationship fields to other Org Unit fields are simple ids. No Org Unit WsDTO should be declared in this bean to avoid circular references.
 * @export
 * @interface BudgetShallow
 */
export interface BudgetShallow {
    /**
     * Boolean flag of whether the Budget is active
     * @type {boolean}
     * @memberof BudgetShallow
     */
    active?: boolean;
    /**
     * Value of Budget
     * @type {number}
     * @memberof BudgetShallow
     */
    budget?: number;
    /**
     * Code of the Budget
     * @type {string}
     * @memberof BudgetShallow
     */
    code?: string;
    /**
     * The name of the Budget
     * @type {string}
     * @memberof BudgetShallow
     */
    name?: string;
    /**
     * 
     * @type {Currency}
     * @memberof BudgetShallow
     */
    currency?: Currency;
    /**
     * The start date of the Budget
     * @type {Date}
     * @memberof BudgetShallow
     */
    startDate?: Date;
    /**
     * The end date of the Budget
     * @type {Date}
     * @memberof BudgetShallow
     */
    endDate?: Date;
    /**
     * Boolean flag whether the budget is selected for a cost center
     * @type {boolean}
     * @memberof BudgetShallow
     */
    selected?: boolean;
}

/**
 * Check if a given object implements the BudgetShallow interface.
 */
export function instanceOfBudgetShallow(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BudgetShallowFromJSON(json: any): BudgetShallow {
    return BudgetShallowFromJSONTyped(json, false);
}

export function BudgetShallowFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetShallow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'budget': !exists(json, 'budget') ? undefined : json['budget'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'currency': !exists(json, 'currency') ? undefined : CurrencyFromJSON(json['currency']),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
    };
}

export function BudgetShallowToJSON(value?: BudgetShallow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'budget': value.budget,
        'code': value.code,
        'name': value.name,
        'currency': CurrencyToJSON(value.currency),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'selected': value.selected,
    };
}

